import { render, staticRenderFns } from "./SingleJoke.vue?vue&type=template&id=64f8118e&scoped=true&"
import script from "./SingleJoke.vue?vue&type=script&lang=js&"
export * from "./SingleJoke.vue?vue&type=script&lang=js&"
import style0 from "./SingleJoke.vue?vue&type=style&index=0&id=64f8118e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f8118e",
  null
  
)

export default component.exports